import { render, h } from "preact";
import { GlobalContextProvider } from "@/context/GlobalContext";
import { SnackbarProvider } from '@/context/SnackbarContext';
import { BrandProvider } from "@/context/MenuContext";
import App from "@/App";
import {
	ApolloClient,
	InMemoryCache,
	ApolloProvider,
} from "@apollo/client";
import { BrowserRouter } from "react-router-dom";

import LogRocket from 'logrocket';
LogRocket.init('cannaplanners/silver-thera');

const cache = new InMemoryCache({
	typePolicies: {
		Checkout: {
			fields: {
				items: {
					merge(existing, incoming){
						return incoming
					}
				}
			}
		}
	}
});

const client = new ApolloClient({
	cache,
	uri: "/wp-json/cannaplanners/v1/graphql/",
});

const target = document.getElementById("root");
if (target) {
	render(
		<BrowserRouter>
			<GlobalContextProvider>
				<BrandProvider>
					<ApolloProvider client={client}>
						<SnackbarProvider>
							<App />
						</SnackbarProvider>
					</ApolloProvider>
				</BrandProvider>
			</GlobalContextProvider>
		</BrowserRouter>,
		target
	);
}
